import { hotlineConsultantCreateText } from '@/feature/hotline/client/create/constant/text';
import { HOTLINE_DISCLOSE, HOTLINE_UN_DISCLOSE, } from '@/feature/hotline/constant/disclose';
import { HOTLINE_SALES_UNDER_10_BILLION, HOTLINE_SALES_BETWEEN_10_AND_100_BILLION, HOTLINE_SALES_BETWEEN_100_AND_500_BILLION, HOTLINE_SALES_BETWEEN_500_AND_1000_BILLION, HOTLINE_SALES_BETWEEN_1000_AND_5000_BILLION, HOTLINE_SALES_BETWEEN_5000_AND_1_TRILLION, HOTLINE_SALES_ABOVE_1_TRILLION, } from '@/feature/hotline/constant/sales';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineConsultantCreateText;
/**
 * 匿名コンサルホットライン 投稿フォームのスキーマ
 */
export const hotlineClientCreateFormSchemaBase = z.object({
    /**
     * 期待するアドバイス
     */
    adviceRequest: z
        .string({ required_error: messages.required(label.adviceRequest()) })
        .min(1, messages.required(label.adviceRequest()))
        .max(10000, messages.maxLength(10000, label.adviceRequest())),
    /**
     * 相談の背景
     */
    description: z
        .string({ required_error: messages.required(label.description()) })
        .min(1, messages.required(label.description()))
        .max(10000, messages.maxLength(10000, label.description())),
    /**
     * 企業名の開示
     */
    disclose: z.union([z.literal(HOTLINE_DISCLOSE.value), z.literal(HOTLINE_UN_DISCLOSE.value)], {
        invalid_type_error: messages.format(label.disclose()),
        required_error: messages.requiredSelect(label.disclose()),
    }),
    /**
     * 業界
     */
    industry: z
        .string({ required_error: messages.required(label.industry()) })
        .min(1, messages.required(label.industry()))
        .max(255, messages.maxLength(255, label.industry())),
    /**
     * 相談希望開始日
     */
    interviewRequestedFromAt: z.date({
        invalid_type_error: messages.format(label.interviewRequestedFromAt()),
        required_error: messages.requiredSelect(label.interviewRequestedFromAt()),
    }),
    /**
     * 相談希望終了
     */
    interviewRequestedToAt: z.date({
        invalid_type_error: messages.format(label.interviewRequestedToAt()),
        required_error: messages.requiredSelect(label.interviewRequestedToAt()),
    }),
    /**
     * 企業規模
     */
    sales: z.union([
        z.literal(HOTLINE_SALES_UNDER_10_BILLION.value),
        z.literal(HOTLINE_SALES_BETWEEN_10_AND_100_BILLION.value),
        z.literal(HOTLINE_SALES_BETWEEN_100_AND_500_BILLION.value),
        z.literal(HOTLINE_SALES_BETWEEN_500_AND_1000_BILLION.value),
        z.literal(HOTLINE_SALES_BETWEEN_1000_AND_5000_BILLION.value),
        z.literal(HOTLINE_SALES_BETWEEN_5000_AND_1_TRILLION.value),
        z.literal(HOTLINE_SALES_ABOVE_1_TRILLION.value),
    ], {
        invalid_type_error: messages.format(label.sales()),
        required_error: messages.requiredSelect(label.sales()),
    }),
    /**
     * 相談タイトル
     */
    title: z
        .string({ required_error: messages.required(label.title()) })
        .min(1, messages.required(label.title()))
        .max(255, messages.maxLength(255, label.title())),
});
/**
 * 匿名コンサルホットライン 投稿フォーム schema
 * @description 各 Field が optional な型
 */
export const hotlineClientCreateFormSchema = hotlineClientCreateFormSchemaBase.refine((data) => data.interviewRequestedToAt > data.interviewRequestedFromAt, {
    message: messages.requiredSelectPeriod(label.interviewRequestedFromAt(), label.interviewRequestedToAt()),
    path: ['interviewRequestedToAt'],
});
